/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, RingProgress, Space, Text } from "@mantine/core";
import React, { useEffect } from "react";
import Chart from "react-apexcharts";
import { BsFillBagCheckFill } from "react-icons/bs";
import { FaEye, FaMoneyCheck } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { allLength } from "../../redux/actions/frontendActions/viewerAction";
function Dashboard_home() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(allLength());
  }, []);

  const { users, blogs, portfolios, messages, pricings ,  userView , orders} = useSelector(
    (state) => state.View
  );

  let TotalOrder = orders.reduce((acc, item) => acc +  item.pPrice ,0 );


  let graphData = []
    if (userView.monthArray?.length > 0) {

        for (let i = 0; i < 12; i++) {
            graphData.push(userView.monthArray[i].viewer)
        }

    }
    

    const chartOptions = {
      series: [
          {
              name: "Visitor",
              data: graphData
          }
      ],
      options: {
          color: ['#181ee8', '#181ee8'],
          chart: {
              background: 'transparent'
          },
          dataLabels: {
              enabled: false
          },
          stroke: {
              curve: 'soomth'
          },
          xaxis: {
              categories: ['Jan', 'Feb', 'Mar', 'Apl', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
          },
          legend: {
              position: 'top'
          },
          grid: {
              show: 'false'
          }
      }
  }

  return (
    <>
      <div className="dashboard_home">
        <Grid columns={12}>
          <Grid.Col md={4} lg={8}>
            {/* // TOP TWO CARD  */}
            <Grid columns={12}>
              <Grid.Col md={4} lg={6}>
                <div className="top-card-body">
                <FaEye color="#fff" size={25} /> 
                  <h1>{userView.viewer > 1 ? `${userView.viewer - 1}+` : userView.viewer}</h1>
                  <p>Total Viewers</p>
                </div>
              </Grid.Col>
              <Grid.Col md={4} lg={6}>
                <div className="top-card-body two">
                  <BsFillBagCheckFill size={25} />
                  <h1>${TotalOrder}.00</h1>
                  <p>Total Orders</p>
                </div>
              </Grid.Col>
            </Grid>
          </Grid.Col>

          <Grid.Col md={4} lg={4}>
            <Grid columns={12}>
              <Grid.Col md={4} lg={12} className="top-small-card-body">
                <div className="icon-area">
                  <FaMoneyCheck size={25} />
                </div>
                <div className="text-area">
                  <h2>$203k</h2>
                  <p>Total Income</p>
                </div>
              </Grid.Col>
            </Grid>

            <Grid columns={12}>
              <Grid.Col md={4} lg={12} className="top-small-card-body white">
                {" "}
                <div className="icon-area">
                  <FaMoneyCheck size={25} />
                </div>
                <div className="text-area">
                  <h2>$203k</h2>
                  <p>Total Income</p>
                </div>
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </div>

      <Space h="xl" />
      <Space h="xl" />
      {/* length_area */}

      <div className="home-dashboard-length-wrapper">
        <Grid columns={12}>
          <Grid.Col md={4} lg={2}>
            <Link
              to="/admin/dashboard/all-portfolio"
              style={{
                color: "#113135",
                textDecoration: "none",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <RingProgress
                size={150}
                label={
                  <Text size="xl" style={{ fontWeight: "bold" }} align="center">
                    { portfolios.length > 0 ? portfolios.length: "Wait" }
                  </Text>
                }
                sections={[{ value: 100, color: "orange" }]}
              />
              <h5>Portfolio</h5>
            </Link>
          </Grid.Col>
          <Grid.Col md={4} lg={2}>
            <Link
              to="/admin/dashboard/all-blog"
              style={{
                color: "#113135",
                textDecoration: "none",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <RingProgress
                size={150}
                label={
                  <Text size="xl" style={{ fontWeight: "bold" }} align="center">
                 {blogs.length > 0 ?blogs.length: "Wait" }
                  </Text>
                }
                sections={[{ value: 100, color: "purple" }]}
              />
              <h5> Blogs</h5>
            </Link>
          </Grid.Col>
          <Grid.Col md={4} lg={2}>
            <Link
              to="/admin/dashboard/all-users"
              style={{
                color: "#113135",
                textDecoration: "none",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <RingProgress
                size={150}
                label={
                  <Text size="xl" style={{ fontWeight: "bold" }} align="center">
                     {users.length > 0 ?users.length: "Wait" }
                  </Text>
                }
                sections={[{ value: 100, color: "#ff561d" }]}
              />
              <h5> users</h5>
            </Link>
          </Grid.Col>
          <Grid.Col md={4} lg={2}>
            <Link
              to="/admin/dashboard/all-orders"
              style={{
                color: "#113135",
                textDecoration: "none",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <RingProgress
                size={150}
                label={
                  <Text size="xl" style={{ fontWeight: "bold" }} align="center">
                      {orders.length > 0 ?orders.length: "Wait" }
                  </Text>
                }
                sections={[{ value: 100, color: "salmon" }]}
              />
              <h5>Orders</h5>
            </Link>
          </Grid.Col>
          <Grid.Col md={4} lg={2}>
            <Link
              to="/admin/dashboard/all-pricing"
              style={{
                color: "#113135",
                textDecoration: "none",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <RingProgress
                size={150}
                label={
                  <Text size="xl" style={{ fontWeight: "bold" }} align="center">
                    { pricings.length > 0 ? pricings.length: "Wait" }
                  </Text>
                }
                sections={[{ value: 100, color: "cyan" }]}
              />
              <h5> Pricing</h5>
            </Link>
          </Grid.Col>
          <Grid.Col md={4} lg={2}>
            <Link
              to="/admin/dashboard/all-messages"
              style={{
                color: "#113135",
                textDecoration: "none",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <RingProgress
                size={150}
                label={
                  <Text size="xl" style={{ fontWeight: "bold" }} align="center">
                     {messages.length > 0 ?messages.length: "Wait" }
                  </Text>
                }
                sections={[{ value: 100, color: "black" }]}
              />
              <h5>Messages</h5>
            </Link>
          </Grid.Col>
        </Grid>
      </div>

      <Space h="xl" />
      <Space h="xl" />

      {/* chart area  */}
      <div className="dashboard-home-chart-area">
        <Grid columns={12}>
          <Grid.Col md={4} lg={12} style={{ width: "100%", height: "50vh" }}>
            <Chart
              options={chartOptions.options}
              series={chartOptions.series}
              type="bar"
              height="100%"
              width="100%"
            />
          </Grid.Col>
        </Grid>
      </div>
    </>
  );
}

export default Dashboard_home;
